import React, { Component } from 'react'
import * as s from './PostalCode.module.css'
import Button from '../../ui/Button'

export default class PostalCode extends Component {
    constructor(props) {
        super(props);
        this.state = {value: ''};
    
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
      }
    
      handleChange(event) {
        this.setState({value: event.target.value});
      }
    
      handleSubmit(event) {
        alert('Postal code: ' + this.state.value);
        event.preventDefault();
      }
    render() {
        return (
            <div className={s.wrapper}>
               <div className={s.content}>
                    <h1 className={s.headline}> Ihre Postleitzahl</h1>
                    <form className={s.form} onSubmit={this.handleSubmit}>
                        <input type="text" value={this.state.value} placeholder="|" onChange={this.handleChange} /><br />
                        <Button buttonText="weiter" />
                    </form>                
               </div>
            </div>
        )
    }
}
